// extracted by mini-css-extract-plugin
export default {"groove_shadow":"input-shadow_groove_shadow__FgzAt","small":"input-shadow_small__LpEZ9","normal":"input-shadow_normal__BSIbr","big":"input-shadow_big__ADkFJ"};